export const themes = {
  default: {
    thRoot: 'reset-list flex flex-row py-3',
    thItem: 'flex-1 font-bold font-sans leading-normal text-center text-current text-sm',
    thItemNth: 'border-l-1',
    thIcon: 'flex items-center justify-center leading-none',
    thIconWidth: '2.625rem',
    thLabels: 'mb-0 mt-2 mx-2',
  },
  list: {
    thRoot: 'reset-list flex flex-wrap -mx-2',
    thItem: 'flex flex-basis-1/2 max-w-1/2 p-2',
    thItemNth: '',
    thIcon: 'flex flex-shrink-0 items-center justify-center leading-none',
    thIconWidth: '1.375rem',
    thLabels: 'font-sans leading-normal px-2 text-base text-gray-darker',
  },
  room: {
    thRoot:
      'Room-icons--row w-full md:w-1/2 grid grid-flow-col grid-rows-1 md:grid-rows-2 md:grid-cols-2 gap-2 md:gap-4 reset-list py-3 md:py-0 md:pb-3 md:rtl:pl-5',
    thItem:
      'py-2 md:px-2 flex flex-col items-center justify-center bg-gray-lighter font-bold font-sans leading-normal text-center text-current text-xs md:text-sm',
    thItemNth: '',
    thIcon: 'leading-none text-xl md:text-3xl',
    thIconWidth: '0.95em',
    thLabels: 'mb-0 mt-2 mx-2  w-full',
  },
  roomColumn: {
    thRoot:
      'Room-icons--column w-full md:w-1/2 grid grid-flow-col grid-rows-1 md:grid-rows-2 md:grid-cols-2 gap-2 md:gap-3 reset-list py-3 md:py-0 md:pb-3 md:rtl:pl-2',
    thItem:
      'py-2 md:px-2 flex flex-col items-center justify-center bg-gray-lighter font-bold font-sans leading-normal text-center text-current text-xs',
    thItemNth: '',
    thIcon: 'leading-none text-xl md:text-3xl',
    thIconWidth: '0.95em',
    thLabels: 'mb-0 mt-2 mx-2 w-full',
  },
  roomSmallColumn: {
    thRoot: 'Room-icons--smallColumn w-full grid grid-flow-col grid-rows-1 gap-2 reset-list py-3',
    thItem:
      'py-2 md:px-2 flex flex-col items-center justify-center bg-gray-lighter font-bold font-sans leading-normal text-center text-current text-xs',
    thItemNth: '',
    thIcon: 'leading-none text-xl md:text-3xl',
    thIconWidth: '0.95em',
    thLabels: 'mb-0 mt-2 mx-2 w-full',
  },
};
